function DocumentFile(data){
    let doc = data || {};
    this.fileName = doc.fileName;
    this.description = doc.description;
    this.fileType = doc.fileType;
}
module.exports = DocumentFile;